<script setup lang="ts">
import Dialog from '@/components/Dialog/Dialog.vue';
import { provide, ref, watch } from 'vue';
import AboutInformation from './AboutInformation.vue';
import { aboutDialogInjectionKey } from './utils';
import CreditsView from '@/views/Credits/CreditsView.vue';
import { mdiStepBackward } from '@mdi/js';

const isOpen = ref(false);
provide(aboutDialogInjectionKey, { isOpen });
const selectedSlide = ref(0);

watch(isOpen, (newValue, oldValue) => {
  if (!newValue && oldValue) {
    selectedSlide.value = 0;
  }
});
</script>

<template>
  <Dialog v-model="isOpen" size="large" :persistent="true" :hideClose="false">
    <template #title>{{ selectedSlide === 0 ? $t('Unicheck') : $t('SoupOverviewTitle') }}</template>
    <template #text>
      <v-window
        v-model="selectedSlide"
        hideDelimiters
        :cycle="false"
        :showArrows="false"
        class="v-window-auto-height"
      >
        <!-- Slide 0 -->
        <v-window-item>
          <AboutInformation @goSoupPage="() => (selectedSlide = 1)" />
        </v-window-item>
        <!-- Slide 1 -->
        <v-window-item>
          <CreditsView />
          <TextVBtn
            v-if="selectedSlide === 1"
            :text="$t('Back')"
            :prependIcon="mdiStepBackward"
            class="mt-2"
            @click="() => (selectedSlide = 0)"
          />
        </v-window-item>
      </v-window>
    </template>
  </Dialog>
  <slot />
</template>
